module.exports = __webpack_public_path__ + "da4c26031ef0b2d500c367049dd721d8.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2022-06-03/whats-new.html
// module id = 2099
// module chunks = 0